import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const TotalRideCountCellContent: React.FC<TotalRideCountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.TotalRideCount];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item.passengers);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item.passengers,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace TotalRideCountCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default TotalRideCountCellContent;
